import styled from 'styled-components';

export const Container = styled.div`
  .material-icons {
    font-size: 20px;
  }

  .document-manager-menu {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    z-index: 10;
    width: 420px;
    max-width: 80vw;
    padding: 8px;
    border: 1px solid ${(props) => props.theme.$gray300};
    border-radius: 4px;
    background: ${(props) => props.theme.$white};
  }

  .document-manager-select__menu {
    position: static;
    margin: 8px 0 0;
    box-shadow: none;
  }

  .document-manager-select__group-heading {
    color: ${(props) => props.theme.$dark};
    font-weight: 600;
    text-transform: none;
  }
`;
